import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  document.title = "DirtEstimator - Privacy Policy";

  return (
    <div>
      {/* Breadcrumb */}
      <section className="breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12 bread-crumb">
              <Link to="/">Home</Link><span> &gt; </span>Privacy Policy
            </div>
          </div>
        </div>
        <hr />
      </section>

      {/* Content */}
      <section className="contentContainer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

                <h2>Privacy Policy</h2>

                <p><strong>Effective Date:</strong> {new Date().getFullYear()}</p>

                <p><strong>1) Who we are</strong><br/>
                    This Privacy Policy describes how <strong>dirtestimator</strong> (“we,” “us,” “our”) collects,
                    uses, discloses, and protects information when you use dirtestimator.net (the “Platform”).
                </p>

                <p>
                    Contact: <a href="mailto:mail@dirtestimator.net">mail@dirtestimator.net</a><br />
                    Address: 1732 Brogan Dr, San Antonio, TX 78232
                </p>

                <p><strong>2) Information we collect</strong><br/></p>

                <p><strong>2.1 Information you provide</strong><br/></p>
                <ul>
                    <li>Contact info: name, email, phone number, company name</li>
                    <li>Listing info: location/address, photos, material description, estimated quantity, access notes, availability windows</li>
                    <li>Messages/support: details you send us</li>
                </ul>

                <p><strong>2.2 Information collected automatically</strong><br/></p>
                <ul>
                    <li>IP address, device type, browser type, pages viewed, timestamps, referring URLs</li>
                    <li>Approximate location inferred from IP</li>
                </ul>

                <p><strong>2.3 Cookies</strong><br/>
                    We may use cookies and local storage for functionality and analytics. You can control cookies through your browser.
                </p>

                <p><strong>3) How we use information</strong><br/></p>
                <ul>
                    <li>Operate and maintain the Platform</li>
                    <li>Create and display Listings</li>
                    <li>Enable Companies to contact Site Posters</li>
                    <li>Provide customer support</li>
                    <li>Prevent fraud and abuse</li>
                    <li>Improve features and user experience</li>
                    <li>Comply with legal obligations</li>
                </ul>

                <p><strong>4) How we share information</strong><br/>
                    <strong>Public Listings:</strong> Listings may be visible to Companies and other users.<br/>
                    <strong>Service providers:</strong> Hosting, analytics, support providers.<br/>
                    <strong>Legal:</strong> If required by law or to protect safety and rights.
                </p>

                <p><strong>5) Sale / Share of personal information</strong><br/>
                    We do not sell personal information or share it for cross-context behavioral advertising.
                </p>

                <p><strong>6) California privacy rights</strong><br/>
                    California residents may request access, deletion, correction, and other rights.<br/>
                    Email: <a href="mailto:mail@dirtestimator.net">mail@dirtestimator.net</a><br />
                    Subject: <strong>California Privacy Request</strong>
                </p>

                <p><strong>7) Data retention</strong><br/>
                    We retain information only as long as needed for operations, legal, and security purposes.
                </p>

                <p><strong>8) Security</strong><br/>
                    We use reasonable security measures, but no system is 100% secure.
                </p>

                <p><strong>9) Third-party services</strong><br/>
                    We may use third-party services such as map providers. Their policies apply.
                </p>

                <p><strong>10) Children’s privacy</strong><br/>
                    The Platform is not intended for children under 13.
                </p>

                <p><strong>11) Changes to this policy</strong><br/>
                    We may update this Privacy Policy and post the revised version here.
                </p>

                <p><strong>12) Contact us</strong><br/>
                    dirtestimator<br />
                    1732 Brogan Dr, San Antonio, TX 78232<br />
                    Email: <a href="mailto:mail@dirtestimator.net">mail@dirtestimator.net</a>
                </p>

            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
